module.exports = __webpack_public_path__ + "static/media/ckn_historial.622cd43a.jpg";